import React from "react";
import { AuthContext } from "@/providers/auth-provider";
import { assert } from "@qrbite/shared/utils/general.utils";

export default function useAuth() {
  const context = React.useContext(AuthContext);
  assert(context, "useAuth must be used within an AuthProvider");
  return context;
}
